<script>
    import { Bar } from 'vue-chartjs'
    import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

    export default {
        extends: Bar,
        props:['items', 'type'],
        mounted () {
            this.rerender()
        },
        methods: {
            rerender() {
                let labels = [],
                    verify = [],
                    event = [],
                    archive = [],
                    candidate = [],
                    all = []
                ;
                this.items.forEach((item) => {
                    if(this.type === 'admin') {
                        labels.push(item.region);
                    } else {
                        labels.push(item.user);
                    }
                    verify.push(item.verify)
                    event.push(item.event)
                    all.push(item.all)
                    archive.push(item.archive)
                    candidate.push(item.candidate)
                });

                // Overwriting base render method with actual data.
                this.renderChart(
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'Верификация',
                                backgroundColor: '#2eadd3',
                                data: verify
                            },
                            {
                                label: 'Участник информационного мероприятия',
                                backgroundColor: '#ffc107',
                                data: event
                            },
                            {
                                label: 'Архив',
                                backgroundColor: '#f5302e',
                                data: archive
                            },
                            {
                                label: 'Кандидат',
                                backgroundColor: '#4dbd74',
                                data: candidate
                            },
                            {
                                label: 'Итого',
                                backgroundColor: '#343a40',
                                data: all
                            }
                        ]
                    },
                    {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        tooltips: {
                            enabled: false,
                            custom: CustomTooltips,
                            intersect: true,
                            mode: 'index',
                            position: 'nearest',
                            callbacks: {
                                labelColor: function (tooltipItem, chart) {
                                    return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
                                }
                            }
                        }
                    }
                )
            }
        },
        watch: {
            items: function() {
                this.rerender();
            }
        }
    }
</script>
